import { createContext } from "react";

const DatabaseSearchContext = createContext();

export default DatabaseSearchContext;
